import { CURRENCY } from './currency';

export const isMatch = (
  value: string | undefined | null,
  confirmValue: string | undefined | null,
  caseSensitive: boolean = true
): boolean => {
  if (!value || !confirmValue) return false;

  const cleanValue = value.trim();
  const cleanConfirm = confirmValue.trim();

  if (caseSensitive) {
    return cleanValue === cleanConfirm;
  }

  return cleanValue.toLowerCase() === cleanConfirm.toLowerCase();
};

/**
 * Safely extracts the calendar date from an ISO string as a plain text string.
 * Completely immune to browser/system timezone shifting.
 * * @example "2026-06-03T14:32:00.000Z" -> "Jun 3, 2026"
 * @returns A formatted date string or '—' if the input is invalid.
 */
export const formatDisplayDate = (dateString?: string | null): string => {
  if (!dateString || typeof dateString !== 'string') return '—';

  try {
    const [year, month, day] = dateString.split('T')[0].split('-');
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${months[Number(month) - 1]} ${Number(day)}, ${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '—';
  }
};

export const formatCurrency = (amount: number) => {
  if (amount === undefined || amount === null) return '-';
  return new Intl.NumberFormat(CURRENCY.locale, {
    style: 'currency',
    currency: CURRENCY.code,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));
};
